export const PRICING_PERIODS = [
  {
    id: "summer-2027",
    label: "01. Mai 2027 \u2013 31. Oktober 2027",
    start: "2027-05-01",
    end: "2027-10-31",
    season: "Summer",
    villa: { single: 140, double: 130 },
    aadya: { single: 130, double: 120 }
  },
  {
    id: "winter-2025-2026",
    label: "01. November 2025 \u2013 30. April 2026",
    start: "2025-11-01",
    end: "2026-04-30",
    season: "Winter",
    villa: { single: 190, double: 170 },
    aadya: { single: 175, double: 155 }
  },
  {
    id: "summer-2026",
    label: "01. Mai 2026 \u2013 31. Oktober 2026",
    start: "2026-05-01",
    end: "2026-10-31",
    season: "Summer",
    villa: { single: 135, double: 125 },
    aadya: { single: 120, double: 110 }
  },
  {
    id: "winter-2026-2027",
    label: "01. November 2026 \u2013 30. April 2027",
    start: "2026-11-01",
    end: "2027-04-30",
    season: "Winter",
    villa: { single: 195, double: 175 },
    aadya: { single: 185, double: 165 }
  }
];
export const RESORTS = [
  { id: "villa", name: "Hiru Villa", japanName: "Hiru Villa", roomTypes: ["double", "junior-suite", "master-suite"] },
  { id: "om", name: "Hiru Om", japanName: "Hiru Om", roomTypes: ["double"] },
  { id: "mudra", name: "Hiru Mudra", japanName: "Hiru Mudra", roomTypes: ["double"] },
  { id: "aadya", name: "Hiru Aadya", japanName: "Hiru Aadya", roomTypes: ["double"] }
];
export const ROOMS_CATALOG = [
  // Hiru Villa - Doppelzimmer
  {
    id: 1,
    resortId: "villa",
    type: "double",
    name: "Doppelzimmer",
    category: "Doppelzimmer",
    description: "Ein ruhiger Raum im Herzen von Hiru Villa, in dem kolonialer Charme und moderne Behaglichkeit harmonisch miteinander verbunden sind. Genie\xDFen Sie entspannte Momente mit Meerblick.",
    image: "/images/Hiru/Hiru Villa's/Room/AH2I3011-Edit-copy.webp",
    size: "32\u33A1",
    occupancy: 2,
    services: [
      { icon: "Maximize", text: "Privater Balkon oder Terrasse" },
      { icon: "Bed", text: "Doppelbett" },
      { icon: "Droplets", text: "Duschraum" },
      { icon: "Wind", text: "Klimaanlage \u2022 Deckenventilator" },
      { icon: "Wifi", text: "Kostenloses Wi-Fi" },
      { icon: "Sparkles", text: "Moskitonetz" }
    ],
    seasonRates: {
      summer: { single: 135, double: 125 },
      winter: { single: 195, double: 175 }
    }
  },
  // Hiru Villa - Junior Suite
  {
    id: 2,
    resortId: "villa",
    type: "junior-suite",
    name: "Junior Suite",
    category: "Junior Suite",
    description: "Ein besonders ruhiger und hochwertiger Raum f\xFCr alle, die mehr Platz und Entspannung genie\xDFen m\xF6chten.",
    image: "/images/Hiru/Hiru Villa's/Junior Suite/680A1902-Edit-copy.webp",
    size: "50\u33A1",
    occupancy: 2,
    services: [
      { icon: "Maximize", text: "Eigenes Meerblick-Terrasse" },
      { icon: "Bed", text: "Ger\xE4umiger Schlafbereich" },
      { icon: "Droplets", text: "Duschraum" },
      { icon: "Wind", text: "Klimaanlage \u2022 Deckenventilator" },
      { icon: "Wifi", text: "Kostenloses Wi-Fi" },
      { icon: "Sparkles", text: "Moskitonetz" }
    ],
    seasonRates: {
      summer: { single: 135, double: 125 },
      winter: { single: 195, double: 175 }
    }
  },
  // Hiru Villa - Master Suite
  {
    id: 3,
    resortId: "villa",
    type: "master-suite",
    name: "Master Suite",
    category: "Master Suite",
    description: "Ein besonderer Raum, in dem Sie die luxuri\xF6seste Zeit in Hiru Villa verbringen k\xF6nnen.",
    image: "/images/Hiru/Hiru Villa's/Master Suite/680A2236-Edit-copy.webp",
    size: "70\u33A1",
    occupancy: 2,
    services: [
      { icon: "Maximize", text: "Terrasse mit sch\xF6nem Ausblick" },
      { icon: "Bed", text: "Ger\xE4umiger Schlafbereich" },
      { icon: "Droplets", text: "Duschraum" },
      { icon: "Wind", text: "Klimaanlage \u2022 Deckenventilator" },
      { icon: "Wifi", text: "Kostenloses Wi-Fi" },
      { icon: "Sparkles", text: "Moskitonetz" }
    ],
    seasonRates: {
      summer: { single: 135, double: 125 },
      winter: { single: 195, double: 175 }
    }
  },
  // Hiru Om - Doppelzimmer
  {
    id: 4,
    resortId: "om",
    type: "double",
    name: "Doppelzimmer",
    category: "Doppelzimmer",
    description: "Ein gro\xDFz\xFCgiger Raum mit etwa 38 m\xB2. Vom privaten Balkon aus genie\xDFen Sie einen wundersch\xF6nen Garten und die ruhige Seeansicht.",
    image: "/images/OM Edited/DSC03211.webp",
    size: "38\u33A1",
    occupancy: 2,
    services: [
      { icon: "Maximize", text: "Privater Balkon" },
      { icon: "Bed", text: "Doppelbett" },
      { icon: "Droplets", text: "Dusche \u2022 WC" },
      { icon: "Wind", text: "Klimaanlage \u2022 Deckenventilator" },
      { icon: "Wifi", text: "Kostenloses Wi-Fi" },
      { icon: "Sparkles", text: "Moskitonetz" }
    ],
    seasonRates: {
      summer: { single: 135, double: 125 },
      winter: { single: 195, double: 175 }
    }
  },
  // Hiru Mudra - Doppelzimmer
  {
    id: 5,
    resortId: "mudra",
    type: "double",
    name: "Doppelzimmer",
    category: "Doppelzimmer",
    description: "Ein ruhiger Innenraum mit etwa 34 m\xB2. Alle Zimmer bieten Meerblick, und von der privaten Terrasse aus erleben Sie das Rauschen der Wellen direkt vor der T\xFCr.",
    image: "/images/Mudra Edited/DSC02016.webp",
    size: "34\u33A1",
    occupancy: 2,
    services: [
      { icon: "Maximize", text: "Privater Balkon mit Meerblick" },
      { icon: "Bed", text: "Doppelbett" },
      { icon: "Droplets", text: "Dusche \u2022 WC" },
      { icon: "Wind", text: "Klimaanlage \u2022 Deckenventilator" },
      { icon: "Wifi", text: "Kostenloses Wi-Fi" },
      { icon: "Sparkles", text: "Moskitonetz" }
    ],
    seasonRates: {
      summer: { single: 135, double: 125 },
      winter: { single: 195, double: 175 }
    }
  },
  // Hiru Aadya - Doppelzimmer
  {
    id: 6,
    resortId: "aadya",
    type: "double",
    name: "Doppelzimmer",
    category: "Doppelzimmer",
    description: "Alle Zimmer haben Meerblick. Der ger\xE4umige Innenraum von etwa 38 m\xB2 ist modern und gem\xFCtlich gestaltet und mit stilvoller Einrichtung ausgestattet.",
    image: "/images/Finalized photos/Edited/DSC01386.webp",
    size: "38\u33A1",
    occupancy: 2,
    services: [
      { icon: "Maximize", text: "Balkon oder Terrasse mit Meerblick" },
      { icon: "Bed", text: "Doppelbett" },
      { icon: "Droplets", text: "Dusche \u2022 WC" },
      { icon: "Wind", text: "Klimaanlage \u2022 Deckenventilator" },
      { icon: "Wifi", text: "Kostenloses Wi-Fi" },
      { icon: "Sparkles", text: "Moskitonetz" }
    ],
    seasonRates: {
      summer: { single: 120, double: 110 },
      winter: { single: 185, double: 165 }
    }
  }
];
export const isSummerSeason = (date) => {
  const month = date.getMonth();
  return month >= 4 && month <= 9;
};
const toPeriodDate = (value) => /* @__PURE__ */ new Date(`${value}T00:00:00`);
export const getPricingPeriod = (date) => PRICING_PERIODS.find((period) => {
  const start = toPeriodDate(period.start);
  const end = toPeriodDate(period.end);
  return date >= start && date <= end;
});
export const getRoomRatesForDate = (room, date) => {
  const period = getPricingPeriod(date);
  if (period) {
    return room.resortId === "aadya" ? period.aadya : period.villa;
  }
  return isSummerSeason(date) ? room.seasonRates.summer : room.seasonRates.winter;
};
export const getResortById = (id) => RESORTS.find((r) => r.id === id);
export const getResortName = (id) => getResortById(id)?.japanName || "";
export const getRoomTypesByResort = (resortId) => getResortById(resortId)?.roomTypes || [];
export const getDisplayNameForRoomType = (roomType) => {
  const typeNames = {
    "double": "Doppelzimmer",
    "junior-suite": "Junior Suite",
    "master-suite": "Master Suite"
  };
  return typeNames[roomType];
};
